<template>
  <div :class="getCss('body-div-dw')">
    <c-dialog v-model="isShow" :option="option"
              @close="closeBtnClick"
              @confirm="closeBtnClick"
              v-transfer-dom>
      <template slot="body">
        <div :class="getCss('reward')" v-show="showDisplayType === 0">
          <div>{{ packageNames }}</div>
        </div>
        <div :class="getCss('isShowGift-content')" v-show="showDisplayType === 1">
          <div :class="getCss('isShowGift-body')" v-if="giftPopIconMap.length > 1">
            <div v-for="(v,key) in giftPopIconMap" :key="key" :class="getCss('isShowGift-div')">
              <div :class="getCss('isShowGift-div-img')">
                <img :src="v.icon" :class="getCss('isShowGift-img')">
              </div>
              <div :class="getCss('isShowGift-div-text')">
                <p >{{ v.name.substr(0,4) }}<span v-if="v.name.length > 5">...</span></p>
              </div>
            </div>
          </div>
          <div v-else :class="getCss('isShowGift-body-one')">
            <div v-for="(v,key) in giftPopIconMap" :key="key" :class="getCss('isShowGift-div-one')">
              <div :class="getCss('isShowGift-div-img-one')">
                <img :src="v.icon" :class="getCss('isShowGift-img-one')">
              </div>
              <div :class="getCss('isShowGift-div-text-one')">
                {{ v.name }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div :class="getCss('footer-show-body')">
          <div :class="getCss('confirm-button')" v-if="metadataFooterData.length === 0">
            <button
              class="ceiba-dialog-ft-button"
              :style="confirmStyle"
              @click="closeBtnClick"
            >
            </button>
          </div>
          <div v-else>
            <div v-for="(v,i) in metadataFooterData" :key="`metadataFooter`+i">
              <div :style="bottomStyle" v-if="v.children[0].metadata_type === 'real_object'">
                <div :class="getCss('address-tips')">提示：实物奖励需填写地址才可以收到</div>
                <button
                  class="ceiba-dialog-ft-button"
                  :style="inputAddressStyle"
                  @click="signAddress"
                >
                </button>
              </div>
              <div :style="bottomStyle" v-else-if="v.children[0].metadata_type === 'cdk'">
                <p :class="getCss('cdk-tips')">CDK: {{ v.children[0].metadata_ext.cdk_value }}</p>
                <div :style="actionStyle" :class="getCss('cdk-action-button')">
                  <button
                    class="ceiba-dialog-ft-button"
                    :style="copyStyle"
                    @click="copyCDkText(v.children[0].metadata_ext.cdk_value, v.children[0].metadata_id)"
                  >
                  </button>
                  <button
                    class="ceiba-dialog-ft-button"
                    :style="downloadGameButtonStyle"
                    @click="startCallDownload"
                    v-show="parseInt(v.children[0].metadata_ext.play_load.isOpenDownload, 10) === 2"
                  >
                  </button>
                </div>
              </div>
              <div :style="v.children[0].metadata_ext.play_load.packageCashInputText
            === '' ? actionStyle : bottomStyle" v-else-if="v.children[0].metadata_type === 'cash'">
                <div :class="getCss('address-tips')">
                  {{ v.children[0].metadata_ext.play_load.packageCashInputText }}&nbsp;</div>
                <button
                  class="ceiba-dialog-ft-button"
                  :style="cashStyle"
                  @click="bindWx"
                >
                </button>
              </div>
              <div :style="v.children[0].metadata_ext.play_load.packageRedPacketInputText
            === '' ? actionStyle : bottomStyle" v-else-if="v.children[0].metadata_type === 'red_packet'">
                <div :class="getCss('address-tips')">
                  {{ v.children[0].metadata_ext.play_load.packageRedPacketInputText}}&nbsp;</div>
                <button
                  class="ceiba-dialog-ft-button"
                  :style="redPacketStyle"
                  @click="rewardRedPacket()"
                >
                </button>
              </div>
              <div :style="actionStyle" v-else-if="v.children[0].metadata_type === 'private_qualification'">
                <button
                  class="ceiba-dialog-ft-button"
                  :style="confirmStyle"
                  @click="privateQualification()"
                >
                </button>
              </div>
              <div :style="actionStyle" v-else-if="v.children[0].metadata_type === 'welfare_center'">
                <button
                  class="ceiba-dialog-ft-button"
                  :style="confirmStyle"
                  @click="welfareCenter()"
                >
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </c-dialog>
    <c-dialog v-model="isShowLucky" :option="luckyOption"
              @close="closeLuckyBtnClick"
              @confirm="closeLuckyBtnClick"
              v-transfer-dom>
      <template slot="body">
        <div :class="getCss('show-lucky-content')">
          <div :class="getCss('show-lucky-content-title-div')">
            <div :class="getCss('show-lucky-content-title')" :style="popTitleStyle">
              恭喜获得
            </div>
            <div :class="getCss('show-lucky-content-title')" :style="popTitleStyle">
              超级珍贵的大奖
            </div>
          </div>
          <div :class="getCss('lucky-img-div')">
            <img :src="luckyImg" :class="getCss('lucky-img')">
          </div>
          <div :class="getCss('lucky-tips-text')">将自动发放至游戏账号/邮箱/QQ帐号</div>
        </div>
      </template>
      <template slot="footer">
        <div :class="getCss('footer-content')">
          <button
            class="ceiba-dialog-ft-button"
            :style="shareButtonStyle"
            @click="createImg"
          >
          </button>
          <button
            class="ceiba-dialog-ft-button"
            :style="nextImgStyle"
            @click="showNext"
            v-if="nextLuckyId > luckyId"
          >
          </button>
          <button
            class="ceiba-dialog-ft-button"
            :style="confirmStyle"
            @click="showGiftPop"
            v-else
          >
          </button>
        </div>
      </template>
    </c-dialog>
    <c-dialog
      v-model="isShowImg" :option="canvasImgOption"
      @close="closeLuckyImgClick"
      @confirm="closeLuckyImgClick"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('lucky-img-canvas-body')">
          <img :src="imageUrl" :class="getCss('show-image-img')"/>
        </div>
        <div :class="getCss('lucky-img-footer-canvas-tips')" v-show="!$ast.isAPP()">
          长按图片保存到本地
        </div>
      </template>
    </c-dialog>
    <div :class="getCss('lucky-img-canvas-body-dom')" v-transfer-dom>
      <div :class="getCss('lucky-img-body')" :id="imgDomId" :style="positionStyle">
        <div :class="getCss('background-img-div')">
          <img
            :class="getCss('background-img')"
            crossorigin="anonymous"
            :src="`${luckyBackgroundImg}?_t=${new Date().getTime()}`"
          />
        </div>
        <div :class="getCss('role-text')">
          <div :class="getCss('user-header')">
            <img
              :class="getCss('user-header-img')"
              :src="userImg"
            />
          </div>
          <div :class="getCss('user-role-info')" v-show="partitionName !== ''">
            <div :class="getCss('user-name')" :style="popTitleStyle">
              {{ userName }}
            </div>
            <div :class="getCss('user-role-area-text')" :style="areaStyle">
              {{ gameName }} {{ deviceName }}-{{ areaName }}-{{ partitionName }}-{{ roleName }}
            </div>
          </div>
          <div :class="getCss('user-role-info1')" v-show="partitionName === ''">
            <div :class="getCss('user-name')" :style="popTitleStyle">
              {{ userName }}
            </div>
          </div>
        </div>
        <div :class="getCss('lottery-num-text')"
             :style="lotteryNumStyle" v-if="showLotteryNum">
          恭喜您第{{ luckyNum }}次就抽中
        </div>
        <div :class="getCss('lottery-num-text')"
             :style="lotteryNumStyle" v-else>
        </div>
        <div :class="getCss('lucky-act-explain-div')" v-show="showCode === true">
          <div :class="getCss('lucky-act-explain-code')">
            <img
              :class="getCss('lucky-act-explain-code-img')"
              :src="qrcodeUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import md5 from 'md5';

const AMS_LOTTREY_MODE = 1; // AMS抽奖模式
const RESOURCE_LOTTERY_MODE = 2; // 资源ID抽奖模式

export default {
  name: 'CPublicRewardBox',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-reward-box-',
      isShow: false,
      isShowLucky: false,
      isShowImg: false,
      giftPopIconMap: [], // 抽中的道具
      sSerialId: '', // 流水id
      rewardBoxData: {}, // 礼包领取数据
      showType: '', // 展示弹窗类型
      luckyImg: 'https://act.xinyue.qq.com/activity/tgclub/11937/14d45abe1c6d5858324af798cae83c23.png',
      luckyId: 0, // 当前欧皇道具序列id
      nextLuckyId: 1, // 下一个欧皇道具序列id
      luckyData: [],
      qrcodeUrl: '',
      imageUrl: '',
      dataEnumeration: {
        cdk: 'cdk',
        packageRealGift: 'real_object',
        cash: 'cash',
        redPacket: 'red_packet',
        privateQualification: 'private_qualification',
        welfareCenter: 'welfare_center',
      },
      metadataFooterData: [],
      luckyBackgroundImg: 'https://act.xinyue.qq.com/test/activity/tgclub/11585/42a7406251eb0dca1a9e497772c636b9.png',
      isLock: false,
      userImg: '',
      headerText: '恭喜获得',
      luckyNum: 0,
      isShowLotteryNum: false,
      isShareLock: false, // 分享锁。App内轮次弹窗如果关闭太快，体验不太友好
    };
  },
  computed: {
    option() {
      return Object.assign({}, this.dialogConfig, {
        footer: true,
        close: true,
        header: this.headerText,
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    luckyOption() {
      return Object.assign({}, this.dialogConfig, {
        footer: true,
        close: true,
        header: false,
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    imgOption() {
      return Object.assign({}, this.dialogConfig, {
        footer: false,
        close: true,
        header: false,
        cancel: false,
        confirm: false,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    canvasImgOption() {
      return Object.assign({}, this.dialogConfig, {
        footer: false,
        close: true,
        header: false,
        cancel: false,
        confirm: false,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    actionStyle() {
      return {};
    },
    bottomStyle() {
      return {
        paddingBottom: '.36rem',
      };
    },
    popTitleStyle() {
      const titleColor = this.configurationData?.titleColor || '#F4D8BA';
      const newTitleColor = this.popStyleTextRgba(titleColor);
      return {
        color: newTitleColor,
      };
    },
    areaStyle() {
      const areaTextColor = this.configurationData?.areaTextColor || '#FFFFFF';
      const newAreaTextColor = this.popStyleTextRgba(areaTextColor);
      return {
        color: newAreaTextColor,
      };
    },
    lotteryNumStyle() {
      const lotteryNumColor = this.configurationData?.lotteryNumColor || '#FFFFFF';
      const newTotteryNumColor = this.popStyleTextRgba(lotteryNumColor);
      return {
        color: newTotteryNumColor,
      };
    },
    inputAddressStyle() {
      const iconArr = this.giftPopIconMap.filter(item => item.children[0].metadata_type === 'real_object');
      const { packageRealGiftInputIcon } = iconArr[0].children[0].metadata_ext.play_load;
      return {
        display: 'block',
        backgroundImage: `url(${packageRealGiftInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        margin: '0 auto',
      };
    },
    copyStyle() {
      const iconArr = this.giftPopIconMap.filter(item => item.children[0].metadata_type === 'cdk');
      const { copyCdkIconImage } = iconArr[0].children[0].metadata_ext.play_load;
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${copyCdkIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    confirmStyle() {
      const bgImg = this.dialogConfig?.confirmStyle?.backgroundImage
        || 'url("https://act.xinyue.qq.com/act/defatulDialogImage/confirm.png")';
      return {
        width: '2.38rem',
        height: '0.64rem',
        backgroundImage: `${bgImg}`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    shareButtonStyle() {
      const bgImg = this.configurationData?.displayStyle[0]?.createImgBtn
        || 'https://act.xinyue.qq.com/activity/tgclub/17280/3fb17692122fe32bb01d304409112833.png';
      return {
        width: '2.38rem',
        height: '0.64rem',
        backgroundImage: `url('${bgImg}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        margin: '0 0',
      };
    },
    nextImgStyle() {
      const bgImg = this.configurationData?.displayStyle[0]?.nextImg
        || 'https://act.xinyue.qq.com/activity/tgclub/17280/8d05a1c158af42db35417170f938fc39.png';
      return {
        width: '2.38rem',
        height: '0.64rem',
        backgroundImage: `url('${bgImg}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        margin: '0 0',
      };
    },
    cashStyle() {
      const iconArr = this.giftPopIconMap.filter(item => item.children[0].metadata_type === 'cash');
      const { packageCashInputIcon } = iconArr[0].children[0].metadata_ext.play_load;
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${packageCashInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        // backgroundSize:'100% 100%',
        margin: '0 auto',
      };
    },
    redPacketStyle() {
      const iconArr = this.giftPopIconMap.filter(item => item.children[0].metadata_type === 'red_packet');
      const { packageRedPacketInputIcon } = iconArr[0].children[0].metadata_ext.play_load;
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${packageRedPacketInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        // backgroundSize:'100% 100%',
        margin: '0 auto',
      };
    },
    downloadGameButtonStyle() {
      const iconArr = this.giftPopIconMap.filter(item => item.children[0].metadata_type === 'cdk');
      const { downloadGameIconImage } = iconArr[0].children[0].metadata_ext.play_load;
      return {
        width: '2.2rem',
        height: '0.65rem',
        display: 'block',
        backgroundImage: `url(${downloadGameIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    packageNames() {
      // 换行展示改成单行展示
      // return this.packageName ? this.packageName.split(',') : '';
      return this.rewardBoxData?.display_config?.msg || '';
    },
    gameName() {
      return this.$actInfo?.game_name || '精品游戏';
    },
    userName() {
      return this.userInfo?.nickName || '';
    },
    deviceName() {
      return this.roleInfo?.device || '';
    },
    areaName() {
      const gid  = this.$actInfo?.gid || 0;
      let areaName = this.roleInfo?.area_id === 1 ? '微信' : 'QQ';
      if (parseInt(gid, 10) === 1191) {
        areaName = this.roleInfo?.area_id > 2 ? '微信' : 'QQ';
        return areaName;
      }
      return areaName;
    },
    partitionId() {
      const partitionId = this.roleInfo?.partition_id > 0 ? this.roleInfo?.partition_id : '';
      return partitionId;
    },
    partitionName() {
      return common.tool.Base64.decode(this.roleInfo?.partition_name || '');
    },
    roleName() {
      return common.tool.Base64.decode(this.roleInfo?.role_name || '');
    },
    avatarImg() {
      let avatarImg = this.userInfo?.avatarUrl || '';
      if (avatarImg === '' && common.tool.getCookie('acctype') === 'wx') {
        avatarImg = 'https://act.xinyue.qq.com/activity/tgclub/17280/2a8f4a1a2c466656925e0bb92e439ba9.png';
      } else {
        if (avatarImg === '') {
          avatarImg = 'https://thirdqq.qlogo.cn/ek_qqapp/AQDq4NDhY1xmU0AUQRqWdpqgClwhq22ojqodmp0iaUibrW7j2bhs9KSuGffIReRQ/40';
        }
      }
      return avatarImg.replace(/\n/g, '');
    },
    showDisplayType() {
      return this.rewardBoxData?.display_config?.display_type || 0;
    },
    showLotteryNum() {
      return this.rewardBoxData?.display_config?.show_num;
    },
    showText() {
      return this.rewardBoxData?.display_config?.show_text;
    },
    showCode() {
      return this.rewardBoxData?.display_config?.show_code;
    },
    imgDomId() {
      return `imgDomId_${this.uid}`;
    },
    positionStyle() {
      return {
        top: '1000rem',
      };
    },
    /**
     * ams抽奖模式
     * @returns {boolean}
     */
    isAmsLotteryMode() {
      const { lotteryMode = AMS_LOTTREY_MODE } = this.configurationData;
      return lotteryMode === AMS_LOTTREY_MODE;
    },
    /**
     * 资源ID抽奖模式
     * @returns {boolean}
     */
    isResourceLotteryMode() {
      const { lotteryMode = AMS_LOTTREY_MODE } = this.configurationData;
      return lotteryMode === RESOURCE_LOTTERY_MODE;
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.$onLogined(() => {
        this.convertToBase64(this.avatarImg);
      });
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    /**
     * 可配置抽奖模式，其他模式抽奖统一处理成ams抽奖模式的数据格式返回。
     * 主要处理response.data.package_id、主要处理response.data.package_name
     * @param responseData
     * @returns {*}
     */
    handlerLotteryModeResponse(responseData = {}) {
      if (this.isResourceLotteryMode) {
        const { data = {} } = responseData;
        const { group = [] } = data;
        const packageIds = [];
        const packageNames = [];
        let packageCdKey = '';
        group.forEach((item) => {
          const { group_id: groupId, amount, name } = item;
          packageNames.push(name);
          if (amount > 1) {
            packageIds.push(`${groupId}:${amount}`);
          } else {
            packageIds.push(`${groupId}`);
          }
          if (!!item.extras) {
            packageCdKey = item.extras;
          }
        });
        return { ...responseData, data: { ...data, package_id: packageIds.join(','), package_name: packageNames.join(','), package_cdkey: packageCdKey } };
      }
      // this.isAmsLotteryMode
      return { ...responseData };
    },
    buildMetaData(configData, responseData) {
      const that = this;
      const packageData = responseData?.data?.packageId || responseData.data?.package_id;
      const packageIdArr = packageData.split(',');
      const packageNameArr = responseData?.data?.package_name.split(',');
      const giftPopIconMap = [];
      let lotteryNum = configData.displayConfig?.lotteryNum || 0;
      packageIdArr.forEach((packageIdItem, key) => {
        const packageIdItemArr = packageIdItem.split(':');
        let forIndex = 1;
        if (packageIdItemArr.length > 1) {
          forIndex = parseInt(packageIdItemArr[1], 10);
        }
        const packageConfigData = configData.packageConfig;
        const newGiftIconArr = packageConfigData.filter(item => parseInt(item.packageId, 10)
          === parseInt(packageIdItemArr[0], 10));
        console.log('newGiftIconArr', newGiftIconArr);
        for (let i = 0; i < forIndex; i++) {
          lotteryNum = lotteryNum + 1;
          const luckyImgItem = that.getLuckyImg(packageIdItemArr[0], lotteryNum);
          let packagePlayType = '';
          if (luckyImgItem !== '' && luckyImgItem !== undefined && luckyImgItem !== 'undefined') {
            packagePlayType = 'lucky';
          }
          const typeArr = this.getGiftType(parseInt(packageIdItemArr[0], 10));
          let itemMetadataType = '';
          if (typeArr && typeArr !== '') {
            itemMetadataType = this.dataEnumeration[typeArr.type];
          }
          const newItemArr = {
            index: newGiftIconArr[0]?.index || 0,
            metadata_type: 'ams_package',
            metadata_id: parseInt(packageIdItemArr[0], 10),
            name: packageNameArr[key],
            icon: newGiftIconArr[0]?.icon || '',
            metadata_ext: {
              lucky_img: `${luckyImgItem}`,
              lottery_num: lotteryNum,
            },
            lottery_payload: {
              play_type: packagePlayType,
            },
            children: [
              {
                index: 0, // 排序idx
                metadata_type: itemMetadataType,
                metadata_id: parseInt(packageIdItemArr[0], 10), // 礼包id
                name: packageNameArr[key], // 礼包名称
                icon: '', // 道具icon
                lottery_payload: {},
                metadata_ext: {
                  cdk_value: '',
                  play_load: typeArr.playload,
                },
              },
            ],
          };
          giftPopIconMap.push(newItemArr);
        }
      });
      const cdkArr = (responseData?.data?.package_cdkey || '').split(',');
      const giftCdkMap = giftPopIconMap.filter(item => item.children[0].metadata_type === 'cdk');
      for (let i = 0;i < giftCdkMap.length;i++) {
        const giftId = giftCdkMap[i].metadata_id;
        const giftKey = giftPopIconMap.findIndex(item => item.metadata_id === giftId);
        this.$set(giftPopIconMap[giftKey].children[0].metadata_ext, 'cdk_value', cdkArr[i]);
      }
      let packageName = responseData.data.msg.replace('恭喜您获得了礼包：', '');
      packageName = packageName.replace(' ', '');
      if (configData?.displayConfig?.ripsText) {
        packageName = configData?.displayConfig?.ripsText;
      }
      const metaConfigData = {
        display_config: {
          display_type: this.configurationData?.displayConfig[0]?.displayType || 0, // 0、默认，1、icon
          msg: packageName, // 默认弹窗展示文案，连抽和单抽 传入文案不一样
          // lucky: true, // 欧皇模式
          header_text: configData?.displayConfig?.headerText || '恭喜获得',
          play_type: configData?.displayConfig?.lotteryPlayType || '', // 玩法模式-欧皇模式 ,兼容多模式
          rare_text: this.configurationData?.displayConfig[0]?.rareText || '恭喜抽中稀有奖励，解锁下一层', // 稀有，轮次抽奖抽中解锁奖励
          show_num: this.configurationData?.displayConfig[0]?.showLotteryNums, // 是否展示抽中次数
          show_code: this.configurationData?.displayConfig[0]?.isShowCode, // 是否展示二维码
        },
        display_style: {
          create_button_img: this.configurationData?.displayStyle[0]?.createImgBtn
            || 'https://act.xinyue.qq.com/activity/tgclub/17280/3fb17692122fe32bb01d304409112833.png',
          next_button_img: this.configurationData?.displayStyle[0]?.nextImg
            || 'https://act.xinyue.qq.com/activity/tgclub/17280/8d05a1c158af42db35417170f938fc39.png',
        },
        metadata_list: giftPopIconMap,
      };
      return metaConfigData;
    },
    getLuckyImg(packageId, lotteryNum) {
      const newLuckyImgArr = this.configurationData?.luckyImgList?.filter(item => parseInt(item.packageId, 10)
        === parseInt(packageId, 10));
      console.log('lotteryNum', lotteryNum, packageId, newLuckyImgArr[0]?.shareLuckyImg);
      newLuckyImgArr.sort((a, b) => parseInt(a.interval, 10) - parseInt(b.interval, 10));
      let luckyImgStr = '';
      if (newLuckyImgArr.length === 1) {
        return newLuckyImgArr[0]?.shareLuckyImg;
      }
      for (let i = 0;i < newLuckyImgArr.length;i++) {
        if (parseInt(lotteryNum, 10) < parseInt(newLuckyImgArr[i].interval, 10)) {
          luckyImgStr = newLuckyImgArr[i]?.shareLuckyImg;
          return luckyImgStr;
        }
      }
      return '';
    },
    getGiftType(packageId) {
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      const res = receiveGiftCustomConfig?.find(item => String(packageId).includes(item.gift_id)) || '';
      return res;
    },
    async showPop(data) {
      this.rewardBoxData = {};
      this.metadataFooterData = [];
      this.luckyData = [];
      this.luckyId = 0;
      this.nextLuckyId = 1;
      this.rewardBoxData = data;
      this.headerText = data.display_config?.header_text;
      if (this.showCode === true) {
        this.getCode();
      }
      this.showType = data.display_config.play_type;
      this.giftPopIconMap = data?.metadata_list || [];
      if (this.giftPopIconMap.length < 1) {
        // this.isShow = true;
        this.showRoutine();
        return false;
      }
      const footerDataArr = this.giftPopIconMap.filter(item => item.children[0].metadata_type === 'cdk'
        || item.children[0].metadata_type === 'real_object' || item.children[0].metadata_type === 'red_packet'
        || item.children[0].metadata_type === 'cash' || item.children[0].metadata_type === 'private_qualification'
        || item.children[0].metadata_type === 'welfare_center');
      if (footerDataArr.length > 0) {
        this.metadataFooterData.push(footerDataArr[0]);
      }
      if (this.showType === 'lucky') {
        this.luckyData = this.giftPopIconMap.filter(item => item.lottery_payload.play_type === 'lucky');
        console.log('this.luckyData', this.luckyData);
        if (this.luckyData.length > 0) {
          this.luckyImg = '';
          this.luckyNum = 0;
          this.luckyImg = this.luckyData[this.luckyId].icon;
          // this.luckyBackgroundImg = '';
          this.luckyBackgroundImg = this.luckyData[this.luckyId].metadata_ext.lucky_img;
          this.luckyNum = this.luckyData[this.luckyId].metadata_ext.lottery_num;
          this.nextLuckyId = this.luckyId + 1;
          if (this.nextLuckyId >= this.luckyData.length) {
            this.nextLuckyId = this.luckyId;
          }
          // this.isShowLucky = true; // 弹窗炫耀一下，下一个
          // await this.showImageShare();
          await this.createImg();
        } else {
          // this.isShow = true;
          this.showRoutine();
        }
      } else {
        // this.isShow = true;
        this.showRoutine();
      }
    },
    showRoutine() {
      const that = this;
      setTimeout(() => {
        // that.luckyBackgroundImg = '';
        that.isShow = true;
      }, 220);
    },
    closeBtnClick() {
      this.isShow = false;
      this.isLock = false;
      // 关联动效
      if (this.configurationData?.showPagEvent) {
        this.$eventBus.$emit('ceiba:common:events:commercial:money:box:anime', {
          varying: this.configurationData?.showPagEvent,
        });
      }
    },
    closeLuckyBtnClick() {
      this.isShowLucky = false;
      this.isLock = false;
    },
    closeLuckyImgClick() {
      if (this.isShareLock) return;
      this.isShowImg = false;
      // 如果不需要欧皇关闭自动弹出下一个图片 注释if内容
      if (this.luckyId < this.luckyData.length) {
        this.luckyNum = 0;
        this.luckyImg = this.luckyData[this.luckyId].icon;
        this.luckyBackgroundImg = this.luckyData[this.luckyId].metadata_ext.lucky_img;
        this.luckyNum = this.luckyData[this.luckyId].metadata_ext.lottery_num;
        // this.showImageShare();
        this.createImg();
      } else {
        if (this.giftPopIconMap.length > 1) {
          this.showRoutine();
        } else {
          // 单抽且是欧皇的时候关联动效
          if (this.configurationData?.showPagEvent) {
            this.$eventBus.$emit('ceiba:common:events:commercial:money:box:anime', {
              varying: this.configurationData?.showPagEvent,
            });
          }
        }
      }
      this.isLock = false;
    },
    async signAddress() {
      console.log('signAddress');
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:events:address-fill', {});
    },
    bindWx() {
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill', { bindType: 'wx' });
    },
    startCallDownload() {
      this.$eventBus.$emit('ceiba:common:events:call-game-download', {});
    },
    copyCDkText(cdk, packageId) {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      textarea.value = cdk;
      textarea.select();
      document.execCommand('copy', true);
      document.body.removeChild(textarea);
      const copyArr = this.giftPopIconMap.filter(item => parseInt(item.children[0].metadata_id, 10)
        === parseInt(packageId, 10));
      const { redirectUrl } = copyArr[0].children[0].metadata_ext.play_load;
      const { redirectTrips } = copyArr[0].children[0].metadata_ext.play_load;
      if (redirectUrl !== '') {
        this.alert({ msg: redirectTrips, confirm() {
          window.location.href = redirectUrl;
        } });
      } else {
        this.$toast('复制cdk成功');
      }
      return true;
    },
    reportFunc(status, giftId) {
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'lottery',
        eventData: {
          gift_id: giftId,
          status,
        },
      });
    },
    // 领取红包 调用引导绑定姓名组件内的领取礼包流程
    rewardRedPacket() {
      const { packageId, sSerialId } = this;
      this.$eventBus.$emit('ceiba:common:events:rewardRedPacket', {
        gift_id: packageId,
        req_serial: sSerialId,
      });
      this.isShow = false;
    },
    /**
     * 展示分享图片，app内拉起图片分享
     * @returns {Promise<void>}
     */
    async showImageShare() {
      try {
        const that = this;
        if (!that.imageUrl) throw '生成分享海报失败';
        // app内图片分享
        if (that.$ast.isAPP()) {
          that.isShareLock = true;
          that.isShowImg = true;
          const url = await this.uploadImage();
          console.log('【CPublicRewardBox】showImageShare url = ', url);
          if (!url) return;
          // 先弹海报，延迟执行分享
          // await this.doSleep(800);
          setTimeout(() => {
            switch (that.$ast?.currentAstName()) {
              case 'TGCLUB': {
                that.$ast?.setImageShare({ imageUrl: url });
                break;
              }
              case 'SPARK': {
                that.$ast?.setImageShare({ iconUrl: url });
                break;
              }
              case 'BB': {
                that.$ast?.setImageShare({ imgUrl: url });
              }
            }
            that.$ast?.imageShare();
            that.isShareLock = false;
          }, 800);
        } else {
          this.isShowImg = true;
        }
        this.luckyId += 1;// 下一个luckId
        console.log('【CPublicRewardBox】showImageShare luckyId = ', this.luckyId);
      } catch (error) {
        this.luckyId = this.luckyData.length;
        this.isShareLock = false;
        console.error('【CPublicRewardBox】showImageShare fail, err = ', error);
      }
    },
    /**
     * 获取图片上传url
     * @param filename
     * @returns {Promise<*>}
     */
    async getUploadUrl({ file }) {
      console.log('【CPublicRewardBox】getUploadUrl file = ', file);
      const fileReg = /image\/(.*)/;
      const regMatchResult = file.type.match(fileReg);
      if (!regMatchResult) return;
      const { name: filename } = file;
      const fileSuffix = `.${regMatchResult?.[1] || 'png'}`;
      const packageId = this.luckyData[this.luckyId].metadata_id;
      console.log('【CPublicRewardBox】getUploadUrl luckyData = ', this.luckyData, ', this.luckyId = ', this.luckyId);
      const fileKey = `${md5(`${this.userAuth['T-OPENID']}${this.userName}${this.roleName}${this.avatarImg}${packageId}${this.luckyNum}${this.qrcodeUrl}`)}${fileSuffix}`;
      console.log('【CPublicRewardBox】getUploadUrl fileKey = ', fileKey);
      console.log('【CPublicRewardBox】getUploadUrl fileKey opid = ', this.userAuth['T-OPENID']);
      console.log('【CPublicRewardBox】getUploadUrl fileKey uName = ', this.userName);
      console.log('【CPublicRewardBox】getUploadUrl fileKey rName = ', this.roleName);
      console.log('【CPublicRewardBox】getUploadUrl fileKey aImg = ', md5(this.avatarImg));
      console.log('【CPublicRewardBox】getUploadUrl fileKey pid = ', packageId);
      console.log('【CPublicRewardBox】getUploadUrl fileKey lNum = ', this.luckyNum);
      console.log('【CPublicRewardBox】getUploadUrl fileKey qUrl = ', md5(this.qrcodeUrl));
      const requestConfig = {
        headers: {
          'T-CHANNEL-ID': this.$actInfo.ast,
          'T-MODE': true,
          ...this.userAuth,
        },
      };
      const url = `https://agw.xinyue.qq.com/action/api/common/getUploadToken?filename=${filename}&file_key=${fileKey}&business=${this.$actInfo.ast}&activity_id=${this.$actInfo.activity_id}`;
      const { ret, msg, data } = await this.$axiosInstance.get(url, requestConfig);
      if (ret) {
        throw new Error(msg);
      }
      return data.url;
    },
    /**
     * base64编码图片上传
     * @returns {Promise<*>}
     */
    async uploadImage() {
      console.log('【CPublicRewardBox】uploadImage this.imageUrl.length = ', this.imageUrl.length);
      if (!this.imageUrl) return;
      const filename = 'luckyShare';
      const file = this.base64toFile(this.imageUrl, filename);
      const url = await this.getUploadUrl({ file });
      console.log('【CPublicRewardBox】uploadImage url = ', url);
      const requestConfig = {
        headers: {
          'Content-Type': file.type,
          'T-CHANNEL-ID': this.$actInfo.ast,
          'T-MODE': true,
          ...this.userAuth,
        },
      };
      await this.$axiosInstance.put(url, file, requestConfig);
      console.log('【CPublicRewardBox】uploadImage request file = ', file);
      const { pathname } = new URL(decodeURIComponent(url));
      return `https://img.xinyue.qq.com${pathname}`;
    },
    /**
     * dom转base64编码图片
     * @returns {Promise<*>}
     */
    async createImg() {
      const that = this;
      // this.getCode();
      if (this.isLock) {
        throw '操作太频繁，请稍后再试~';
      }
      that.isLock = true;
      setTimeout(async () => {
        try {
          that.imageUrl = '';
          window.scroll(0, 0);
          const canvasDom = document.getElementById(that.imgDomId);
          const width = canvasDom.offsetWidth;
          const height = canvasDom.offsetHeight;
          const canvas = document.createElement('canvas');
          const getPixelRatio = function (context) {
            const backingStore = context?.backingStorePixelRatio
              || context?.webkitBackingStorePixelRatio
              || context?.mozBackingStorePixelRatio
              || context?.msBackingStorePixelRatio
              || context?.oBackingStorePixelRatio
              || context?.backingStorePixelRatio || 1;
            return (window.devicePixelRatio || 1) / backingStore;
          };
          const scale = getPixelRatio(canvasDom);
          canvas.width = width * scale;
          canvas.height = height * scale;
          canvas.style.width = `${width}px`;
          canvas.style.height = `${height}px`;
          const context = canvas.getContext('2d');
          context.beginPath();
          context.arc(100 * scale, 100 * scale, 2 * scale, 0, 2 * Math.PI);
          context.fillStyle = '#fff';
          context.fill();
          context.closePath();
          context.scale(scale, scale);
          const opts = {
            scale: 1,
            canvas,
            backgroudColor: 'null',
            width: window.screen.width, // width,
            height: window.screen.height - 1, // height,
            dpi: window.devicePixelRatio * 2,
            useCORS: true,
            allowTaint: false,
          };
          // 清除分享后生成的iframe节点。html2canvas会重新加载页面所有的iframe，如果存在多个分享iframe会导致执行多次分享
          this.removeShareIframeElement();
          await html2canvas(canvasDom, opts).then((canvas) => {
            console.log('canvasDom', canvasDom);
            console.log('opts', opts);
            console.log('canvas', canvas);
            that.imageUrl = canvas.toDataURL('image/png');
            that.isLock = false;
            canvas.remove();
            that.showImageShare();
          });
        } catch (error) {
          console.error('【CPublicRewardBox】createImg fail, err = ', error);
          that.isLock = false;
          throw '当前版本不支持，请更新至最新版本';
        }
      }, 300);
    },
    /**
     * 清除分享后生成的iframe节点。html2canvas会重新加载页面所有的iframe，如果存在多个分享iframe会导致执行多次分享
     */
    removeShareIframeElement() {
      const iframeElements = document.getElementsByTagName('iframe');
      let iframeSrcFlag = '';
      if (this.$ast.isAPP() && this.$ast.currentAstName() === 'SPARK') {
        iframeSrcFlag = 'jsbridge://share/showShareDialogV2';
      }
      if (this.$ast.isAPP() && this.$ast.currentAstName() === 'BB') {
        iframeSrcFlag = 'gamehelper:shareImage:';
      }
      if (!iframeSrcFlag) return;
      for (let i = iframeElements.length - 1; i >= 0; i--) {
        const { src } = iframeElements[i];
        if (src.indexOf(iframeSrcFlag) > -1) {
          iframeElements[i].remove();
        }
      }
    },
    showNext() {
      this.imageUrl = '';
      // this.luckyBackgroundImg = '';
      this.luckyNum = 0;
      this.luckyImg = this.luckyData[this.nextLuckyId].icon;
      this.luckyBackgroundImg = this.luckyData[this.nextLuckyId].metadata_ext.lucky_img;
      this.luckyNum = this.luckyData[this.luckyId].metadata_ext.lottery_num;
      this.luckyId = this.nextLuckyId;
      this.nextLuckyId = this.nextLuckyId + 1;
      if (this.nextLuckyId >= this.luckyData.length) {
        this.nextLuckyId = this.luckyId;
      }
    },
    showGiftPop() {
      this.isShowLucky = false;
      // this.isShow = true;
      if (this.giftPopIconMap.length > 1) {
        this.showRoutine();
      }
      this.imageUrl = '';
    },
    getCode() {
      const that = this;
      const darkColor = this.configurationData?.codeDarkColor || '#FFFFFF';
      const lineColor = this.configurationData?.codeLineColor || '#00000000';
      const newDarkColor = this.popStyleTextRgba(darkColor);
      const newLineColor = this.popStyleTextRgba(lineColor);
      const urlLink = window.location.href.split('?')[0];
      const viaStr = common.tool.getQueryParams('via', window.location.href);
      let newUrlLink = `${urlLink}?via=${viaStr}`;
      if (!viaStr) {
        newUrlLink = urlLink;
      }
      console.log('newUrlLink', newUrlLink);
      QRCode.toDataURL(newUrlLink, {
        color: {
          dark: newDarkColor,
          light: newLineColor,
        },
        style: {
          width: 104,
          height: 104,
        },
        margin: 0.2,
      }).then((url) => {
        that.qrcodeUrl = url;
        console.log(url);
      })
        .catch((e) => {
          console.log(e);
        });
    },
    /**
     * base64图片转文件流
     * @param base64Image base64编码
     * @param filename 文件名
     * @returns {File}
     */
    base64toFile(base64Image, filename = 'imageFile') {
      const arr = base64Image.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const suffix = mime.split('/')[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      // eslint-disable-next-line no-plusplus
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    async convertToBase64(url) {
      const that = this;
      const homeImage = new Image();
      // 解决跨域问题
      homeImage.setAttribute('crossOrigin', 'anonymous');
      homeImage.src = url;
      // homeImage.onload为异步加载
      homeImage.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 100;
        // console.log('homeImage.width', homeImage.width);
        canvas.height = 100;
        const context = canvas.getContext('2d');
        context.drawImage(homeImage, 0, 0, homeImage.width, homeImage.height, 0, 0, 100, 100);
        const quality = 1;
        const dataURL = canvas.toDataURL('image/png', quality);
        that.userImg = dataURL;
        canvas.remove();
      };
    },
    privateQualification() {
      this.isShow = false;
      this.isLock = false;
    },
    welfareCenter() {
      this.isShow = false;
      this.isLock = false;
    },
    // 颜色rbg转换
    popStyleTextRgba(rgbData) {
      const matchStr = /rgb/g;
      const isRgb = rgbData.match(matchStr);
      if (!isRgb) {
        return rgbData;
      }
      const rgbStr = rgbData.replace('rgba(', '');
      const rgbStr1 = rgbStr.replace(')', '');
      const rgbArr = rgbStr1.split(',');
      const hexArr = [];
      const hex = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
      for (let i = 0;i < 3;i++) {
        let r = null;
        let c = rgbArr[i];
        const g = rgbArr[i];
        while (c > 16) {
          r = c % 16;
          c = (c / 16) >> 0;
          hexArr.push(hex[r]);
        }
        hexArr.push(hex[c]);
        if (g < 16) {
          hexArr.push('0');
        }
      }
      if (rgbArr.length > 3) {
        let opacityNum = Math.round(255 * rgbArr[3]);
        let rOpacityNum = null;
        const gOpacityNum = opacityNum;
        while (opacityNum > 16) {
          rOpacityNum = opacityNum % 16;
          opacityNum = (opacityNum / 16) >> 0;
        }
        hexArr.push(hex[opacityNum]);
        hexArr.push(hex[rOpacityNum]);
        if (gOpacityNum < 16) {
          hexArr.push('0');
        }
      }
      const hexStr = `#${hexArr.join('')}`;
      console.log(hexStr);
      return hexStr;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
